'use strict';

var d3 = require('d3');
var Scales = function Scales() {
  function prepareXScale(params, rangeFrom, rangeTo) {
    return d3.scale.linear().domain([rangeFrom, rangeTo]).range([0, params.width - params.chartPadding.right]);
  }
  function prepareYScale(yMax, params) {
    return d3.scale.linear().domain([0, yMax]).range([params.height - params.chartPadding.bottom, params.chartPadding.top]);
  }
  function prepareAxisYScale(yMax, yScale, params) {
    return d3.scale.linear().domain([0, yMax]).range([yScale(0), params.chartPadding.top]);
  }
  return function (params, data) {
    var seatAvailIndexRange = d3.extent(data, function (d) {
      return d.seatAvailIndex;
    });
    var seatAvailIndexRangeFrom = seatAvailIndexRange[0];
    var seatAvailIndexRangeTo = seatAvailIndexRange[1];
    var yAxisRange = d3.extent(data, function (d) {
      return d.bidPrice;
    });
    var xScale = prepareXScale(params, seatAvailIndexRangeFrom, seatAvailIndexRangeTo);
    var yScale = prepareYScale(yAxisRange[1], params);
    var axisYScale = prepareAxisYScale(yAxisRange[1], yScale, params);
    return {
      xScale: xScale,
      yScale: yScale,
      axisYScale: axisYScale
    };
  };
};
Scales.$inject = [];
module.exports = Scales;